import $ from 'jquery';
import whatInput from 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
import Foundation from 'foundation-sites';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './lib/slick'; 
import './lib/intersection-observer'; 
//import './lib/recaptcha-script'; 

$(document).foundation();

$(document).on('click', 'a[href^="#"]:not([role="tab"]):not([data-open]):not([data-toggle])', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});




$(document).ready(function () {
  const $slider = $('.testimonial-slider');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll('.animated-blur');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // optional: animate only once
      }
    });
  }, {
    threshold: 0.1
  });

  elements.forEach(el => observer.observe(el));
});







//////////////////////////////////////////////////////
/////          for bokeh animation           /////////
//////////////////////////////////////////////////////


let animationPaused = false;
let bokehParticles = [];

const colorSchemes = {
    coolWhites: [
        { center: 'rgba(255, 255, 255, 0.9)', mid: 'rgba(245, 235, 220, 0.6)', edge: 'rgba(230, 215, 190, 0.2)' },
        { center: 'rgba(255, 255, 255, 0.8)', mid: 'rgba(250, 240, 225, 0.5)', edge: 'rgba(235, 220, 195, 0.2)' },
        { center: 'rgba(255, 255, 255, 0.7)', mid: 'rgba(240, 230, 210, 0.4)', edge: 'rgba(225, 210, 185, 0.1)' }
    ]
};

const currentSchemeColors = colorSchemes.coolWhites;

function random(min, max) {
    return Math.random() * (max - min) + min;
}

function getRandomColor() {
    return currentSchemeColors[Math.floor(Math.random() * currentSchemeColors.length)];
}

function createTwinkleParticle(containerElement) {
    const minSize = 30;
    const maxSize = 100;
    const twinkleSpeed = 1;
    const intensity = 4.3;
    const driftAmount = 50;

    const particle = document.createElement('div');
    particle.className = 'bokeh-particle';

    const size = random(minSize, maxSize);
    const rect = containerElement.getBoundingClientRect();

    // Position randomly within container
    const x = random(10, rect.width - size - 10);
    const y = random(10, rect.height - size - 10);

    // Twinkle timing variations for natural randomness
    const twinkleDuration = random(1.5, 4) / (twinkleSpeed * 0.5);
    const twinkleDelay = random(0, 3);
    const driftDuration = random(15, 30);
    const driftDelay = random(0, 10);

    // Get random color from the scheme
    const colorSet = getRandomColor();

    // Intensity-based opacity ranges
    const baseIntensity = intensity / 5;
    const opacityMin = baseIntensity * 0.1;
    const opacityMid = baseIntensity * 0.5;
    const opacityMax = baseIntensity * 1;

    // Scale variations for twinkle effect
    const scaleMin = 0.6 + (size / maxSize) * 0.2;
    const scaleMid = 0.9 + (size / maxSize) * 0.2;
    const scaleMax = 1.1 + (size / maxSize) * 0.3;

    // Subtle drift movements
    const driftMultiplier = driftAmount * 2;
    const driftX1 = random(-driftMultiplier, driftMultiplier);
    const driftY1 = random(-driftMultiplier, driftMultiplier);
    const driftX2 = random(-driftMultiplier, driftMultiplier);
    const driftY2 = random(-driftMultiplier, driftMultiplier);
    const driftX3 = random(-driftMultiplier, driftMultiplier);
    const driftY3 = random(-driftMultiplier, driftMultiplier);

    // Set CSS custom properties
    particle.style.setProperty('--color-center', colorSet.center);
    particle.style.setProperty('--color-mid', colorSet.mid);
    particle.style.setProperty('--color-edge', colorSet.edge);

    particle.style.setProperty('--base-opacity', opacityMid);
    particle.style.setProperty('--opacity-min', opacityMin);
    particle.style.setProperty('--opacity-mid', opacityMid);
    particle.style.setProperty('--opacity-max', opacityMax);

    particle.style.setProperty('--scale-min', scaleMin);
    particle.style.setProperty('--scale-mid', scaleMid);
    particle.style.setProperty('--scale-max', scaleMax);

    particle.style.setProperty('--blur-min', `${size * 0.02}px`);
    particle.style.setProperty('--blur-mid', `${size * 0.04}px`);
    particle.style.setProperty('--blur-max', `${size * 0.06}px`);

    particle.style.setProperty('--twinkle-duration', `${twinkleDuration}s`);
    particle.style.setProperty('--twinkle-delay', `${twinkleDelay}s`);

    particle.style.setProperty('--drift-duration', `${driftDuration}s`);
    particle.style.setProperty('--drift-delay', `${driftDelay}s`);
    particle.style.setProperty('--drift-x1', `${driftX1}px`);
    particle.style.setProperty('--drift-y1', `${driftY1}px`);
    particle.style.setProperty('--drift-x2', `${driftX2}px`);
    particle.style.setProperty('--drift-y2', `${driftY2}px`);
    particle.style.setProperty('--drift-x3', `${driftX3}px`);
    particle.style.setProperty('--drift-y3', `${driftY3}px`);

    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;

    return particle;
}

function generateBokeh(targetSelector = '.hero-bokeh') {
    const targetElements = document.querySelectorAll(targetSelector);

    bokehParticles = [];

    targetElements.forEach(element => {
        if (getComputedStyle(element).position === 'static') {
            element.style.position = 'relative';
        }

        let bokehLayer = element.querySelector('.bokeh-layer');
        if (!bokehLayer) {
            bokehLayer = document.createElement('div');
            bokehLayer.className = 'bokeh-layer';
            element.appendChild(bokehLayer);
        }

        const particleCount = 40; // fixed number of particles
        bokehLayer.innerHTML = '';

        for (let i = 0; i < particleCount; i++) {
            const particle = createTwinkleParticle(element);
            bokehLayer.appendChild(particle);
            bokehParticles.push(particle);
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    generateBokeh();
});

document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.logo-scroll-track');
  if (!track) return;

  // Function to calculate and set scroll width
  function setScrollWidth() {
    const totalLogos = track.children.length / 3;
    
    // Calculate the width of one complete set
    let oneSetWidth = 0;
    for (let i = 0; i < totalLogos; i++) {
      const item = track.children[i];
      const rect = item.getBoundingClientRect();
      oneSetWidth += rect.width;
    }

    // Set the CSS variable for the animation distance
    track.style.setProperty('--scroll-width', `${oneSetWidth}px`);
    
    // Calculate duration based on speed (pixels per second)
    const pixelsPerSecond = 120; // Adjust this value for speed (lower = slower)
    const duration = oneSetWidth / pixelsPerSecond;
    track.style.animationDuration = `${duration}s`;
    
    console.log('Scroll width:', oneSetWidth, 'Duration:', duration); // Debug log
  }

  // Wait for images to load before calculating
  if (document.readyState === 'complete') {
    setScrollWidth();
  } else {
    window.addEventListener('load', setScrollWidth);
  }

  // Recalculate on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setScrollWidth, 250);
  });
});